import { EthersSigner } from "../EthersSigner.js";
import { WalletClientSigner } from "@alchemy/aa-core";
import { UNIQUE_PROPERTIES_PER_SIGNER } from "../Constants.js";
export const convertSigner = async (signer, skipChainIdCalls = false) => {
    let resolvedSmartAccountSigner;
    let rpcUrl = null;
    let chainId = null;
    const isAnAlchemySigner = UNIQUE_PROPERTIES_PER_SIGNER.alchemy in signer;
    const isAnEthersSigner = UNIQUE_PROPERTIES_PER_SIGNER.ethers in signer;
    const isAViemSigner = UNIQUE_PROPERTIES_PER_SIGNER.viem in signer;
    if (!isAnAlchemySigner) {
        if (isAnEthersSigner) {
            const ethersSigner = signer;
            if (!skipChainIdCalls) {
                if (!ethersSigner.provider) {
                    throw new Error("Cannot consume an ethers Wallet without a provider");
                }
                const chainIdFromProvider = await ethersSigner.provider.getNetwork();
                if (!chainIdFromProvider?.chainId) {
                    throw new Error("Cannot consume an ethers Wallet without a chainId");
                }
                chainId = Number(chainIdFromProvider.chainId);
            }
            resolvedSmartAccountSigner = new EthersSigner(ethersSigner, "ethers");
            rpcUrl = ethersSigner.provider?.connection?.url ?? null;
        }
        else if (isAViemSigner) {
            const walletClient = signer;
            if (!walletClient.account) {
                throw new Error("Cannot consume a viem wallet without an account");
            }
            if (!skipChainIdCalls) {
                if (!walletClient.chain) {
                    throw new Error("Cannot consume a viem wallet without a chainId");
                }
                chainId = walletClient.chain.id;
            }
            resolvedSmartAccountSigner = new WalletClientSigner(walletClient, "viem");
            rpcUrl = walletClient?.transport?.url ?? null;
        }
        else {
            throw new Error("Unsupported signer");
        }
    }
    else {
        resolvedSmartAccountSigner = signer;
    }
    return { signer: resolvedSmartAccountSigner, rpcUrl, chainId };
};
//# sourceMappingURL=convertSigner.js.map